import React from 'react';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useUser } from './useUser';
import { routes } from '../routes';

type TUseAuthRoutes = {
  hasAccess: boolean;
};

export function useAuthRoutes(): TUseAuthRoutes {
  const [user] = useUser();
  const session = useSession();
  const router = useRouter();

  const [hasAccess, setHasAccess] = React.useState(false);

  React.useEffect(() => {
    if (user) {
      // verify user rol to know if he has access to this page
      const currentRoute = routes.find((route) =>
        router.pathname.includes(route.href)
      );
      // if he dont has access

      if (!currentRoute?.privileges?.includes(user.userType)) {
        router.push('/app/dashboard');
        return;
      }
      setHasAccess(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.data?.user, session?.status, user]);

  return { hasAccess };
}
